var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c;
import { Vue, Component, Prop, Watch, Ref } from "vue-facing-decorator";
import { Feature, SystemsClient, SystemComponentTreeNodesClient, LookupsClient, CompaniesClient, GetSystemTrendChartQuery, GetSystemTrendChartQueryModel, SystemComponentTreeModel, SystemComponentQueryModel, MeasurementCategoryModel, SystemAccessQueryModel, GetSystemTrendChartLimitQueryModel, StringStatusEnum, ComponentTypeEnum, BatteryTypeEnum, LithiumBatteryTypeEnum } from "@/app/api/battery-portal-api";
import { HttpHelper } from "@/app/utils/http-helper";
import { Notifier } from "@//common/utils/notifier";
import { ArrayHelper } from "@/app/utils/array-helper";
import { DateHelper } from "@/app/utils/date-helper";
import { CacheHelper } from "@/app/utils/cache-helper";
import RouteNames from "@/app/router/routes";
import { DatePresetOption } from "@/common/enums/date-preset";
import ComponentTreeVue from "@/app/vues/shared/component-tree.vue";
import pako from 'pako';
const systemsClient = new SystemsClient(window.apiUrl);
const companyClient = new CompaniesClient(window.apiUrl);
const systemComponentTreeNodesClient = new SystemComponentTreeNodesClient(window.apiUrl);
const lookupClient = new LookupsClient(window.apiUrl);
let TrendGraphFilterVue = class TrendGraphFilterVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.componentTreeLoaded = false;
        this.componentTreeKey = 0;
        this.oldComponentTypeId = 0;
        this.locationsModalVisible = false;
        this.selectAllByDefault = false;
        // snapshot day interval slider
        this.snapshotDayIntervals = [1, 2, 7, 14, 28];
        this.snapshotDayIntervalIndex = 1;
        this.autoSuggestInterval = true;
        this.isPlotting = false;
        // query parameters
        this.querySystemId = 0;
        this.queryStringId = 0;
        this.queryStringStatusId = 0;
        this.queryBlockId = 0;
        this.queryNodes = null;
        this.queryMeasurementTypeId = 0;
        this.queryStartDate = null;
        this.queryEndDate = null;
        // models
        this.datePickerConfig = DateHelper.GetDefaultDatePickerConfig();
        this.componentTree = new SystemComponentTreeModel();
        this.dateFilterOptions = ["W", "M", "3M", "Y", "..."];
        this.dateFilterOption = "";
        // arrays
        this.dateFilterPresets = ArrayHelper.defaultDateFilters;
        this.companies = [];
        this.selectedCompany = null;
        this.systems = new Array();
        this.measurementCategories = new Array();
        this.measurementCategory = new MeasurementCategoryModel();
        // save Settings
        this.measureTypePerCategory = new Array();
    }
    created() {
        this.restoreCachedFilter();
        this.setParametersBasedOnQueryString(this.$route);
        this.getLookups();
    }
    ;
    mounted() {
        // Set initial index based on current value
        const currentValue = this.query.snapshotDayInterval || 1;
        const index = this.snapshotDayIntervals.indexOf(currentValue);
        this.snapshotDayIntervalIndex = index >= 0 ? index : 0;
    }
    ;
    setParametersBasedOnQueryString(route) {
        var _a;
        // If there is a query in place, check if it is valid. If so, it will not ready the params from the route.
        var trendQuery = route.query.trendQuery;
        if (trendQuery) {
            try {
                let axesQuery = null;
                try {
                    // Convert base64url to binary data
                    const base64 = trendQuery.replace(/-/g, '+').replace(/_/g, '/');
                    const binaryString = atob(base64);
                    const compressed = new Uint8Array(binaryString.length);
                    for (let i = 0; i < binaryString.length; i++) {
                        compressed[i] = binaryString.charCodeAt(i);
                    }
                    // Decompress data
                    const decompressed = pako.inflate(compressed);
                    const jsonString = new TextDecoder().decode(decompressed);
                    const data = JSON.parse(jsonString);
                    axesQuery = GetSystemTrendChartQuery.fromJS(data);
                }
                catch (e) {
                    // fallback to use old uncompressed format
                    console.warn('Error reading trendQuery - Falling back to uncompressed format', e);
                    axesQuery = GetSystemTrendChartQuery.fromJS(JSON.parse(atob(trendQuery)));
                }
                this.dateFilterOption = "...";
                if (((_a = axesQuery.axes) === null || _a === void 0 ? void 0 : _a.length) < this.index + 1)
                    return;
                var query = axesQuery.axes[this.index];
                this.querySystemId = query.systemId;
                this.queryMeasurementTypeId = query.measurementTypeId;
                this.queryNodes = query.nodes;
                this.queryStartDate = query.startTime;
                this.queryEndDate = query.endTime;
                return;
            }
            catch (e) {
                console.error("Error reading trendQuery", e);
            }
        }
        this.querySystemId = parseInt(route.params.systemId || 0);
        this.queryStringId = parseInt(route.params.stringId || 0);
        this.queryStringStatusId = parseInt(route.params.stringStatusId || 0);
        this.queryBlockId = parseInt(route.params.blockId || 0);
        this.queryMeasurementTypeId = parseInt(route.params.measurementTypeId || 0);
        let startDateString = (route.params.startDate || "").toString();
        if (startDateString) {
            this.dateFilterOption = "...";
            this.queryStartDate = DateHelper.convertToDate(startDateString);
        }
        let endDateString = (route.params.endDate || "").toString();
        if (endDateString) {
            this.queryEndDate = DateHelper.convertToDate(endDateString);
        }
    }
    ;
    // get
    getLookups() {
        companyClient
            .getListGET()
            .then(response => {
            let companies = (response || []).map((item) => {
                return {
                    value: item.companyId,
                    text: item.companyName || ""
                };
            });
            this.companies = [{ value: null, text: `Any company` }].concat(companies);
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
        });
        lookupClient
            .getMeasurementCategoriesWithMeasurementTypes(true)
            .then(response => {
            if (!response)
                return;
            this.measurementCategories = response;
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
        systemsClient
            .getSystems(false, Feature.TrendGraph)
            .then(response => {
            if (!response)
                return;
            let systemModel = new SystemAccessQueryModel();
            systemModel.init({});
            systemModel.displayName = this.selectPlaceholderSystem;
            this.systems = [systemModel].concat(response);
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
    }
    ;
    getComponentTree() {
        this.componentTreeLoaded = false;
        if (!this.systemId) {
            let componentTree = new SystemComponentTreeModel();
            componentTree.init({});
            this.componentTree = componentTree;
            this.componentTreeLoaded = true;
            return;
        }
        ;
        systemComponentTreeNodesClient
            .getSystemLocations(this.systemId)
            .then(response => {
            var _a, _b;
            this.componentTree = response;
            this.componentTreeLoaded = true;
            if (((_a = this.queryNodes) === null || _a === void 0 ? void 0 : _a.length) > 0)
                setTimeout(() => { this.selectQueryNodes(); }, 100);
            else if (this.selectAllByDefault && ((_b = this.query.nodes) === null || _b === void 0 ? void 0 : _b.length) == 0)
                setTimeout(() => { this.selectAllLocations(); }, 100);
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
    }
    ;
    refreshComponentTree() {
        this.componentTreeKey += 1;
    }
    ;
    clear() {
        this.queryBlockId = 0;
        this.queryStringId = 0;
        this.query.nodes = [];
    }
    ;
    resetFilters() {
        this.clear();
        this.setDefaults();
    }
    ;
    setDateFilterOption(option) {
        this.dateFilterOption = option;
    }
    ;
    resetDateFilterOption() {
        this.dateFilterOption = "3M";
    }
    ;
    setMeasurementType(item) {
        this.query.measurementTypeId = item.measurementTypeId;
        this.query.measurementTypeName = item.measurementTypeName;
    }
    ;
    setMeasurementCategory(option) {
        this.saveMeasurementTypePerCategory();
        this.measurementCategory = option;
        this.restoreMeasurementTypePerCategory();
    }
    ;
    getMeasurementCategory() {
        return this.measurementCategory;
    }
    saveMeasurementTypePerCategory() {
        if (!this.measurementCategory.measurementCategoryId) {
            return;
        }
        var category = this.measureTypePerCategory.find(x => x.categoryId == this.measurementCategory.measurementCategoryId);
        if (category) {
            category.measurementTypeId = this.query.measurementTypeId;
            category.measurementTypeName = this.query.measurementTypeName;
            this.query.measurementTypeId = 0;
        }
        else {
            category = {
                categoryId: this.measurementCategory.measurementCategoryId,
                measurementTypeId: this.query.measurementTypeId,
                measurementTypeName: this.query.measurementTypeName
            };
            this.measureTypePerCategory.push(category);
        }
    }
    restoreMeasurementTypePerCategory() {
        var category = this.measureTypePerCategory.find(x => x.categoryId == this.measurementCategory.measurementCategoryId);
        if (!category)
            return;
        this.query.measurementTypeId = (category === null || category === void 0 ? void 0 : category.measurementTypeId) || 0;
        this.query.measurementTypeName = (category === null || category === void 0 ? void 0 : category.measurementTypeName) || "";
    }
    // computed
    get visibleComponentTree() {
        try {
            let measurementType = this.measurementType;
            if (!measurementType)
                return null;
            if (this.oldComponentTypeId != measurementType.componentTypeId) {
                this.clear();
                if (this.selectAllByDefault)
                    setTimeout(() => { this.selectAllLocations(); }, 100);
            }
            this.oldComponentTypeId = measurementType.componentTypeId || 0;
            let result = new Array();
            let searchTree = (root, nodes) => {
                if (nodes == null || root == null)
                    return;
                let items = new Array();
                for (let i = 0; i < nodes.length; i++) {
                    let item = new SystemComponentQueryModel();
                    item.init(nodes[i]);
                    items.push(item);
                }
                ;
                let hasValidChild = (children) => {
                    if (children == null)
                        return false;
                    for (let i = 0; i < children.length; i++) {
                        if (children[i].componentTypeId == this.measurementType.componentTypeId) {
                            return true;
                        }
                        if (hasValidChild(children[i].children || null)) {
                            return true;
                        }
                    }
                    return false;
                };
                for (let i = 0; i < items.length; i++) {
                    let item = items[i];
                    if (item.componentTypeId == this.measurementType.componentTypeId || hasValidChild(item.children || null)) {
                        item.children = [];
                        root.push(item);
                        searchTree(item.children, nodes[i].children || null);
                    }
                }
            };
            searchTree(result, this.componentTree.children || null);
            return result;
        }
        catch (ex) {
            console.error(ex);
            return null;
        }
    }
    ;
    get systemHasComponents() {
        if (!this.visibleComponentTree)
            return false;
        let components = this.visibleComponentTree;
        return (components && components.length) ? true : false;
    }
    ;
    get measurementTypes() {
        let data = new Array();
        let categories = this.measurementCategories;
        for (let i = 0; i < categories.length; i++) {
            let types = categories[i].measurementTypes;
            if (!types)
                continue;
            for (let j = 0; j < types.length; j++) {
                data.push(types[j]);
            }
        }
        return data;
    }
    ;
    get systemId() {
        return this.query.systemId;
    }
    ;
    get system() {
        var system = this.systems.filter(item => {
            return item.systemId == this.systemId;
        })[0];
        return system;
    }
    ;
    set system(item) {
        if (!item || !item.systemId)
            return;
        this.clear();
        this.$emit("clearAxis", this.index);
        this.query.systemId = item.systemId;
    }
    ;
    get measurementTypeId() {
        return this.query.measurementTypeId;
    }
    ;
    get measurementTypeName() {
        return this.query.measurementTypeName;
    }
    ;
    get measurementType() {
        let match = this.measurementTypes.filter(item => {
            return item.measurementTypeId == this.measurementTypeId && item.measurementTypeName == this.measurementTypeName;
        })[0];
        return match;
    }
    ;
    get systemsLoaded() {
        return this.systems && this.systems.length ? true : false;
    }
    ;
    get measurementTypesLoaded() {
        return this.measurementTypes && this.measurementTypes.length ? true : false;
    }
    ;
    get filtersReady() {
        return this.systemsLoaded
            && this.measurementTypesLoaded;
    }
    ;
    get selectPlaceholderSystem() {
        return "Please select a System";
    }
    ;
    get selectPlaceholderMeasurement() {
        return "Please select a Measurment Type";
    }
    ;
    get preselectedComponentId() {
        if (this.queryBlockId)
            return this.queryBlockId;
        if (this.queryStringId)
            return this.queryStringId;
        return 0;
    }
    ;
    get showDatePickers() {
        return this.dateFilterOption == "...";
    }
    ;
    // observables
    setDefaults() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            if (!this.systems.length || !this.systems[1])
                return;
            try {
                let preselectedSystemId = this.querySystemId;
                let preselectedMeasurementTypeId = this.queryMeasurementTypeId;
                if (preselectedSystemId) {
                    let idx = ArrayHelper.findFirstIndex(this.systems, (match) => {
                        return match.systemId == preselectedSystemId;
                    });
                    this.query.systemId = idx >= 0 ? preselectedSystemId : this.systems[1].systemId;
                    yield this.$nextTick();
                }
                if (preselectedMeasurementTypeId) {
                    let idx = ArrayHelper.findFirstIndex(this.measurementTypes, (match) => {
                        return match.measurementTypeId == preselectedMeasurementTypeId;
                    });
                    let measurementType = idx > 0 ? this.measurementTypes[idx] : this.measurementTypes[0];
                    this.query.measurementTypeId = measurementType.measurementTypeId;
                    this.query.measurementTypeName = measurementType.measurementTypeName;
                    if (measurementType.measurementCategoryId) {
                        let measurementCategory = this.measurementCategories.filter(category => category.measurementCategoryId == measurementType.measurementCategoryId)[0];
                        if (measurementCategory)
                            this.setMeasurementCategory(measurementCategory);
                    }
                    let isAmbTemp2 = this.$route.query.isAmbTemp2 === 'true';
                    if (isAmbTemp2 && idx < this.measurementTypes.length) {
                        let measurementType = this.measurementTypes[idx + 1];
                        this.query.measurementTypeId = measurementType.measurementTypeId;
                        this.query.measurementTypeName = measurementType.measurementTypeName;
                    }
                }
                else {
                    this.resetMeasurementType();
                }
                // note: dates will be lost on page reload as these are not currently added to query string in the route
                if (this.queryStartDate) {
                    this.query.startTime = this.queryStartDate;
                    this.query.endTime = this.queryEndDate ? this.queryEndDate : DateHelper.addDay(this.queryStartDate, 7);
                }
                else {
                    this.dateFilterOption = "3M";
                }
                if (this.preselectedComponentId) {
                    let limitQuery = new GetSystemTrendChartLimitQueryModel({
                        nodeId: this.preselectedComponentId,
                        stringStatusId: ((_a = this.queryStringStatusId) !== null && _a !== void 0 ? _a : 0 > 0) ? (_b = this.queryStringStatusId) !== null && _b !== void 0 ? _b : StringStatusEnum.Float : StringStatusEnum.Float
                    });
                    this.query.limitQuery = limitQuery;
                }
                // save the preselected component id before loading the component tree as this will clear the selection
                let preselectedComponentIdBefore = this.preselectedComponentId;
                this.$emit("axisLoaded", this.index);
                if (preselectedComponentIdBefore && this.index == 0) {
                    yield this.$nextTick();
                    this.query.nodes = [preselectedComponentIdBefore];
                    this.$emit("plot", this.index);
                }
            }
            catch (ex) {
                console.error(ex);
            }
        });
    }
    ;
    setDefaultDates() {
        let dateRange = this.query && this.query.startTime && this.query.endTime ?
            { start: this.query.startTime, end: this.query.endTime } :
            DateHelper.getDateRange(DatePresetOption.Default);
        switch (this.dateFilterOption) {
            case "W":
                dateRange = DateHelper.getDateRange(DatePresetOption.SevenDays);
                break;
            case "M":
                dateRange = DateHelper.getDateRange(DatePresetOption.OneMonth);
                break;
            case "3M":
                dateRange = DateHelper.getDateRange(DatePresetOption.ThreeMonths);
                break;
            case "Y":
                dateRange = DateHelper.getDateRange(DatePresetOption.OneYear);
                break;
        }
        this.query.startTime = dateRange.start;
        this.query.endTime = dateRange.end;
    }
    ;
    loadComponentTree(newSystemId, oldSystemId) {
        if (!this.system)
            return;
        this.query.companyId = this.system.companyId;
        this.getComponentTree();
        if (oldSystemId)
            this.resetMeasurementType();
    }
    ;
    updateMeasurementType() {
        this.$emit("measurementTypeChanged", this.index);
    }
    ;
    onSelectedCompanyChanged() {
        this.query.systemId = null;
    }
    ;
    resetMeasurementType() {
        let measurementType = this.measurementTypes[0];
        this.query.measurementTypeId = measurementType.measurementTypeId;
        this.query.measurementTypeName = measurementType.measurementTypeName;
        if (measurementType.measurementCategoryId) {
            let measurementCategory = this.measurementCategories.filter(category => category.measurementCategoryId == measurementType.measurementCategoryId)[0];
            if (measurementCategory)
                this.setMeasurementCategory(measurementCategory);
        }
        else
            this.setMeasurementCategory(this.measurementCategories[0]);
    }
    get isSystemInvalid() {
        return !this.systemId && this.searchAttempted ? true : false;
    }
    ;
    get areDatesInvalid() {
        if (!this.query.startTime || !this.query.endTime)
            return false;
        let startTime = DateHelper.convertToDate(this.query.startTime.toString());
        let endTime = DateHelper.convertToDate(this.query.endTime.toString());
        return (startTime >= endTime) && this.searchAttempted ? true : false;
    }
    ;
    get startDateInvalid() {
        if (!this.query.startTime)
            return true;
        try {
            return isNaN(Date.parse(this.query.startTime.toString()));
        }
        catch (_a) {
            return false;
        }
    }
    ;
    get endDateInvalid() {
        if (!this.query.endTime)
            return true;
        try {
            return isNaN(Date.parse(this.query.endTime.toString()));
        }
        catch (_a) {
            return false;
        }
    }
    ;
    get isMeasurementInvalid() {
        return !this.measurementTypeId && this.searchAttempted ? true : false;
    }
    ;
    get areNodesInvalid() {
        var _a, _b;
        if ((!((_a = this.query) === null || _a === void 0 ? void 0 : _a.nodes) || !((_b = this.query) === null || _b === void 0 ? void 0 : _b.nodes.length)) && this.searchAttempted)
            return true;
        return false;
    }
    ;
    get locationsModalId() {
        return "modal-discharge-locations-" + this.index.toString();
    }
    countStringsSelected() {
        var _a;
        var count = 0;
        (_a = this.visibleComponentTree) === null || _a === void 0 ? void 0 : _a.forEach(item => {
            var _a, _b;
            if ((_b = (_a = this.query) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.includes(item.componentId)) {
                count++;
            }
            else if (item.children) {
                const hasSelectedChild = (children) => {
                    var hasChild = false;
                    children.forEach(childItem => {
                        var _a, _b, _c;
                        if ((_b = (_a = this.query) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.includes(childItem.componentId)) {
                            hasChild = true;
                            return;
                        }
                        if (((_c = childItem.children) === null || _c === void 0 ? void 0 : _c.length) && hasSelectedChild(childItem.children)) {
                            hasChild = true;
                            return;
                        }
                    });
                    return hasChild;
                };
                if (hasSelectedChild(item.children))
                    count++;
            }
        });
        return count;
    }
    countBlocksSelected(root) {
        var count = root.filter(x => { var _a, _b; return ((_b = (_a = this.query) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.includes(x.componentId)) && x.componentTypeId == ComponentTypeEnum.Block; }).length;
        root.forEach(item => {
            if (item.children) {
                count += this.countBlocksSelected(item.children);
            }
        });
        return count;
    }
    countModuleTempSensorSelected(root) {
        var moduleTempSensorTypeIds = [ComponentTypeEnum.CellTemp, ComponentTypeEnum.TerminalTemp];
        var count = root.filter(x => { var _a, _b; return ((_b = (_a = this.query) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.includes(x.componentId)) && moduleTempSensorTypeIds.includes(x.componentTypeId); }).length;
        root.forEach(item => {
            if (item.children) {
                count += this.countModuleTempSensorSelected(item.children);
            }
        });
        return count;
    }
    countAmbTempSelected(root) {
        var count = root.filter(x => { var _a, _b; return ((_b = (_a = this.query) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.includes(x.componentId)) && x.componentTypeId == ComponentTypeEnum.Sensor; }).length;
        root.forEach(item => {
            if (item.children) {
                count += this.countAmbTempSelected(item.children);
            }
        });
        return count;
    }
    get selectedLocationsPlaceholder() {
        var _a, _b;
        if (!this.visibleComponentTree || !this.systemHasComponents) {
            return "No Locations Available";
        }
        if (((_b = (_a = this.query) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.length) == 0) {
            return "Please select Locations";
        }
        return "";
    }
    get selectedLocationsText() {
        var _a, _b;
        if (!this.visibleComponentTree || !this.systemHasComponents || ((_b = (_a = this.query) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.length) == 0) {
            return "";
        }
        var stringCount = this.countStringsSelected();
        var blockCount = this.countBlocksSelected(this.visibleComponentTree);
        var ambTempCount = this.countAmbTempSelected(this.visibleComponentTree);
        var moduleTempSensorCount = this.countModuleTempSensorSelected(this.visibleComponentTree);
        var textToDisplay = `Selected ${stringCount} String${stringCount > 1 ? 's' : ''}`;
        if (blockCount > 0) {
            textToDisplay += ` and ${blockCount} Block${blockCount > 1 ? 's' : ''}`;
        }
        else if (ambTempCount > 0) {
            textToDisplay += ` and ${ambTempCount} Amb. Temp. Sensor${blockCount > 1 ? 's' : ''}`;
        }
        else if (moduleTempSensorCount > 0) {
            textToDisplay += ` and ${moduleTempSensorCount} Temp. Sensor${moduleTempSensorCount > 1 ? 's' : ''}`;
        }
        return textToDisplay;
    }
    ;
    selectAllLocations() {
        this.queryBlockId = 0;
        this.queryStringId = 0;
        if (!this.visibleComponentTree || !this.systemHasComponents)
            return;
        const allSelectableNodes = [];
        // Helper function to recursively collect all selectable node IDs
        const collectSelectableNodes = (nodes) => {
            nodes.forEach(node => {
                allSelectableNodes.push(node.componentId);
                if (node.children) {
                    collectSelectableNodes(node.children);
                }
            });
        };
        // Collect all selectable nodes
        collectSelectableNodes(this.visibleComponentTree);
        this.query.nodes = allSelectableNodes;
    }
    ;
    selectQueryNodes() {
        var _a;
        if (!((_a = this.queryNodes) === null || _a === void 0 ? void 0 : _a.length) || !this.visibleComponentTree || !this.systemHasComponents) {
            return;
        }
        // Recursively collect all componentIds from visibleComponentTree
        const collectIds = (nodes) => {
            const ids = new Set();
            const traverse = (items) => {
                for (const item of items) {
                    ids.add(item.componentId);
                    if (item.children && item.children.length) {
                        traverse(item.children);
                    }
                }
            };
            traverse(nodes);
            return ids;
        };
        const validIds = collectIds(this.visibleComponentTree);
        // Only add queryNodes that exist in visibleComponentTree (root or any child)
        this.query.nodes = this.queryNodes.filter(id => validIds.has(id));
        this.queryNodes = [];
    }
    unselectAllLocations() {
        this.clear();
    }
    ;
    get selectedLocationsTitle() {
        var _a, _b, _c;
        if (!this.visibleComponentTree || !this.systemHasComponents || ((_b = (_a = this.query) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.length) == 0) {
            return "";
        }
        var title = "";
        var firstString = true;
        (_c = this.visibleComponentTree) === null || _c === void 0 ? void 0 : _c.forEach(item => {
            if (item.children) {
                var blocks = item.children.filter(x => { var _a, _b; return (_b = (_a = this.query) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.includes(x.componentId); });
                if (blocks.length > 0) {
                    if (!firstString) {
                        title += "; ";
                    }
                    title += `${item.componentName} Block${blocks.length > 1 ? 's' : ''}: `;
                    var firstBlock = true;
                    blocks.forEach(block => {
                        if (!firstBlock) {
                            title += ", ";
                        }
                        title += block.componentCode;
                        firstBlock = false;
                    });
                    firstString = false;
                }
            }
        });
        return title;
    }
    ;
    get isLithium() {
        return this.system && this.system.batteryTypeId == BatteryTypeEnum.Lithium;
    }
    get isLithiumSamsungG3() {
        return this.system && this.system.batteryTypeId == BatteryTypeEnum.Lithium && this.system.lithiumBatteryTypeId == LithiumBatteryTypeEnum.SamsungGen3;
    }
    get measurementCategoriesVisible() {
        if (this.isLithium) {
            if (this.isLithiumSamsungG3)
                return this.measurementCategories;
            return this.measurementCategories.filter(item => item.measurementCategoryId < 5);
        }
        else {
            return this.measurementCategories.filter(item => item.measurementCategoryId < 4);
        }
    }
    get measurementTypeVisible() {
        var _a, _b;
        if (this.isLithium)
            return (_a = this.measurementCategory.measurementTypes) === null || _a === void 0 ? void 0 : _a.filter(item => this.isLithiumSamsungG3 ? item.visibleForLithiumSamsungGen3 : item.visibleForLithium);
        else {
            return (_b = this.measurementCategory.measurementTypes) === null || _b === void 0 ? void 0 : _b.filter(item => item.visibleForNonLithium);
        }
    }
    get measurementTypeRequiresNode() {
        if (!this.measurementCategory)
            return true;
        let measurementCategorySystem = 4;
        return this.measurementCategory.measurementCategoryId != measurementCategorySystem;
    }
    get showCompanySelect() {
        return this.companies.length > 2;
    }
    ;
    get visibleSystems() {
        return this.systems.filter(item => { var _a; return ((_a = this.selectedCompany) === null || _a === void 0 ? void 0 : _a.value) == null || this.selectedCompany.value == item.companyId; });
    }
    get maxValidIntervalIndex() {
        var _a, _b;
        // Calculate number of days in the selected period
        let dayCount = 90; // Default to 3 months if dates not set
        if (((_a = this.query) === null || _a === void 0 ? void 0 : _a.startTime) && ((_b = this.query) === null || _b === void 0 ? void 0 : _b.endTime)) {
            const startTime = new Date(this.query.startTime);
            const endTime = new Date(this.query.endTime);
            const diffTime = Math.abs(endTime.getTime() - startTime.getTime());
            dayCount = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        }
        // Ensure at least 7 data points per period
        // Find the last index where interval allows at least 7 points: dayCount / interval >= 7
        const MIN_POINTS = 7;
        for (let i = this.snapshotDayIntervals.length - 1; i >= 0; i--) {
            const interval = this.snapshotDayIntervals[i];
            const pointsCount = Math.ceil(dayCount / interval);
            if (pointsCount >= MIN_POINTS) {
                return i;
            }
        }
        // If no interval gives us 7 points, return 0 (smallest interval)
        return 0;
    }
    isIntervalDisabled(index) {
        return index > this.maxValidIntervalIndex;
    }
    updateSnapshotDayInterval() {
        // Prevent selecting disabled intervals
        if (this.snapshotDayIntervalIndex > this.maxValidIntervalIndex) {
            this.snapshotDayIntervalIndex = this.maxValidIntervalIndex;
            return;
        }
        this.query.snapshotDayInterval = this.snapshotDayIntervals[this.snapshotDayIntervalIndex];
    }
    validateIntervalIndex() {
        // If the current selection is now invalid, reset to the max valid interval
        if (this.snapshotDayIntervalIndex > this.maxValidIntervalIndex) {
            this.snapshotDayIntervalIndex = this.maxValidIntervalIndex;
        }
    }
    onAutoSuggestIntervalChanged() {
        if (this.autoSuggestInterval) {
            this.applySuggestedInterval();
        }
        // Store the preference in cache
        CacheHelper.storeItem(RouteNames.Trend, "autoSuggestInterval", this.autoSuggestInterval);
    }
    onChartParametersChanged() {
        if (this.autoSuggestInterval && !this.isPlotting) {
            this.applySuggestedInterval();
        }
    }
    applySuggestedInterval() {
        const suggestedInterval = this.calculateOptimalInterval();
        const index = this.snapshotDayIntervals.indexOf(suggestedInterval);
        if (index >= 0) {
            this.snapshotDayIntervalIndex = index;
        }
    }
    setPlotting(isPlotting) {
        this.isPlotting = isPlotting;
    }
    calculateOptimalInterval() {
        var _a, _b, _c, _d;
        // Target: Keep total data points under a manageable threshold
        // For JSChart, aim for ~10,000-15,000 points max for smooth interaction
        const MAX_OPTIMAL_POINTS = 10000;
        const MAX_ACCEPTABLE_POINTS = 15000;
        const locationCount = ((_b = (_a = this.query) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.length) || 1;
        // Calculate number of days in the selected period
        let dayCount = 90; // Default to 3 months if dates not set
        if (((_c = this.query) === null || _c === void 0 ? void 0 : _c.startTime) && ((_d = this.query) === null || _d === void 0 ? void 0 : _d.endTime)) {
            const startTime = new Date(this.query.startTime);
            const endTime = new Date(this.query.endTime);
            const diffTime = Math.abs(endTime.getTime() - startTime.getTime());
            dayCount = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        }
        // Get max valid interval index to ensure we don't suggest invalid intervals
        const maxValidIndex = this.maxValidIntervalIndex;
        // Try to find the smallest interval that keeps us under the optimal threshold
        // Start from the smallest interval (1 day) and work up, but don't exceed maxValidIndex
        for (let i = 0; i <= maxValidIndex; i++) {
            const interval = this.snapshotDayIntervals[i];
            const pointsPerLocation = Math.ceil(dayCount / interval);
            const totalPoints = locationCount * pointsPerLocation;
            // If this interval keeps us under the optimal threshold, use it
            if (totalPoints <= MAX_OPTIMAL_POINTS) {
                return interval;
            }
        }
        // If no interval keeps us under optimal, find the smallest one that's under acceptable
        for (let i = 0; i <= maxValidIndex; i++) {
            const interval = this.snapshotDayIntervals[i];
            const pointsPerLocation = Math.ceil(dayCount / interval);
            const totalPoints = locationCount * pointsPerLocation;
            if (totalPoints <= MAX_ACCEPTABLE_POINTS) {
                return interval;
            }
        }
        // If even the largest valid interval doesn't help, use it anyway and warn
        const largestValidInterval = this.snapshotDayIntervals[maxValidIndex];
        const pointsPerLocation = Math.ceil(dayCount / largestValidInterval);
        const totalPoints = locationCount * pointsPerLocation;
        return largestValidInterval;
    }
    storeFilterToCache() {
        CacheHelper.storeItem(RouteNames.Trend, "selectAllByDefault", this.selectAllByDefault);
    }
    ;
    restoreCachedFilter() {
        this.selectAllByDefault = CacheHelper.getItem(RouteNames.Trend, "selectAllByDefault");
        // Restore auto-suggest interval preference (default to true if not set)
        const cachedAutoSuggest = CacheHelper.getItem(RouteNames.Trend, "autoSuggestInterval");
        this.autoSuggestInterval = cachedAutoSuggest !== null && cachedAutoSuggest !== undefined ? cachedAutoSuggest : true;
    }
    getPeriodTitle(item) {
        return DateHelper.getDateFilterOptionTitle(item);
    }
};
__decorate([
    Prop(),
    __metadata("design:type", Number)
], TrendGraphFilterVue.prototype, "index", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof GetSystemTrendChartQueryModel !== "undefined" && GetSystemTrendChartQueryModel) === "function" ? _a : Object)
], TrendGraphFilterVue.prototype, "query", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], TrendGraphFilterVue.prototype, "searchAttempted", void 0);
__decorate([
    Ref("componentTreeVueList"),
    __metadata("design:type", typeof (_b = typeof Array !== "undefined" && Array) === "function" ? _b : Object)
], TrendGraphFilterVue.prototype, "componentTreeVueList", void 0);
__decorate([
    Watch("filtersReady"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
], TrendGraphFilterVue.prototype, "setDefaults", null);
__decorate([
    Watch("dateFilterOption"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], TrendGraphFilterVue.prototype, "setDefaultDates", null);
__decorate([
    Watch("query.systemId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], TrendGraphFilterVue.prototype, "loadComponentTree", null);
__decorate([
    Watch("measurementTypeName"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], TrendGraphFilterVue.prototype, "updateMeasurementType", null);
__decorate([
    Watch("selectedCompany"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], TrendGraphFilterVue.prototype, "onSelectedCompanyChanged", null);
__decorate([
    Watch("snapshotDayIntervalIndex"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], TrendGraphFilterVue.prototype, "updateSnapshotDayInterval", null);
__decorate([
    Watch("maxValidIntervalIndex"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], TrendGraphFilterVue.prototype, "validateIntervalIndex", null);
__decorate([
    Watch("autoSuggestInterval"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], TrendGraphFilterVue.prototype, "onAutoSuggestIntervalChanged", null);
__decorate([
    Watch("query.nodes"),
    Watch("query.startTime"),
    Watch("query.endTime"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], TrendGraphFilterVue.prototype, "onChartParametersChanged", null);
__decorate([
    Watch("selectAllByDefault"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], TrendGraphFilterVue.prototype, "storeFilterToCache", null);
TrendGraphFilterVue = __decorate([
    Component({
        name: "TrendGraphFilterVue",
        components: {
            ComponentTreeVue
        },
        emits: ["axisLoaded", "clearAxis", "plot", "measurementTypeChanged"],
        expose: ['getMeasurementCategory', 'resetFilters', 'setPlotting']
    })
], TrendGraphFilterVue);
export default TrendGraphFilterVue;
